(function (root, factory) {
  var api = factory(root || {});

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.InfrarediPreorderOfferDate = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function parseDate(value) {
    var match = String(value || '').match(/(?:^|\D)(\d{4})-(\d{2})-(\d{2})(?!\d)/);
    if (!match) return null;

    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var date = new Date(year, month - 1, day);

    if (
      date.getFullYear() !== year
      || date.getMonth() !== month - 1
      || date.getDate() !== day
    ) {
      return null;
    }

    return date;
  }

  function mapValue(map, key) {
    if (!map || key === null || typeof key === 'undefined') return null;
    return map[key] || map[String(key)] || null;
  }

  function marketText(config, variantId, marketId) {
    var marketMap = config && config.variantsShippingTextForMarket;
    var variantMap = mapValue(marketMap, variantId);
    if (!variantMap || marketId === null || typeof marketId === 'undefined') return null;

    var id = String(marketId).replace('gid://shopify/Market/', '');
    return mapValue(variantMap, id) || mapValue(variantMap, 'gid://shopify/Market/' + id);
  }

  function liveConfigs(explicitConfig) {
    var configs = [];
    if (explicitConfig) configs.push(explicitConfig);
    if (root._RestockRocketConfig && configs.indexOf(root._RestockRocketConfig) === -1) {
      configs.push(root._RestockRocketConfig);
    }
    if (root._StoqConfig && configs.indexOf(root._StoqConfig) === -1) {
      configs.push(root._StoqConfig);
    }
    return configs;
  }

  function dateForVariant(options) {
    options = options || {};
    var configs = liveConfigs(options.config);
    var date = null;

    for (var i = 0; i < configs.length && !date; i += 1) {
      date = parseDate(marketText(configs[i], options.variantId, options.marketId));
    }

    date = date
      || parseDate(options.offerText)
      || parseDate(options.scheduledDate);

    for (var j = 0; j < configs.length && !date; j += 1) {
      date = parseDate(mapValue(configs[j] && configs[j].variantsShippingText, options.variantId));
    }

    return date || parseDate(options.legacyDate);
  }

  function ordinal(day) {
    var remainder100 = day % 100;
    if (remainder100 >= 11 && remainder100 <= 13) return day + 'th';
    if (day % 10 === 1) return day + 'st';
    if (day % 10 === 2) return day + 'nd';
    if (day % 10 === 3) return day + 'rd';
    return day + 'th';
  }

  function formatWeek(date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) return '';
    return WEEKDAYS[date.getDay()] + ' ' + ordinal(date.getDate()) + ' of ' + MONTHS[date.getMonth()];
  }

  return {
    parseDate: parseDate,
    dateForVariant: dateForVariant,
    formatWeek: formatWeek
  };
});
